const aiAgentsTypes = {
  RESET_AI_AGENT_STATE: 'RESET_AI_AGENT_STATE',

  SYNC_AI_AGENTS: {
    REQUEST: 'SYNC_AI_AGENTS.REQUEST',
    SUCCESS: 'SYNC_AI_AGENTS.SUCCESS',
    FAILURE: 'SYNC_AI_AGENTS.FAILURE',
  },

  CREATE_AI_AGENT: {
    REQUEST: 'CREATE_AI_AGENT.REQUEST',
    SUCCESS: 'CREATE_AI_AGENT.SUCCESS',
    FAILURE: 'CREATE_AI_AGENT.FAILURE',
  },

  UPDATE_AI_AGENT: {
    REQUEST: 'UPDATE_AI_AGENT.REQUEST',
    SUCCESS: 'UPDATE_AI_AGENT.SUCCESS',
    FAILURE: 'UPDATE_AI_AGENT.FAILURE',
  },
};

export default aiAgentsTypes;
